import axios from '../../axios.js'
import { setIdleTimeout } from '@/plugins/idleTimer.js'
export default {
  fetchCurrency({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .get('/tenants/currency', {
          params: payload,
        })
        .then((response) => {
          commit('SET_CURRENCY', response.data.toUpperCase())
          localStorage.setItem('tenant_currency', response.data.toUpperCase())
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  removeEmailTemplate({ commit }, objId) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/tenant-email-templates/${objId}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  updateEmailTemplate(context, obj) {
    return new Promise((resolve, reject) => {
      axios
        .patch('/tenant-email-templates/' + obj.id, obj.obj)
        .then(async (response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  postEmailTemplate(context, items) {
    return new Promise((resolve, reject) => {
      axios
        .post('/tenant-email-templates/bulk', { bulk: items })
        .then(async (response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  updateTenant({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios
        .put('/tenants/' + item.tenantId, item)
        .then(async (response) => {
          commit('UPDATE_TENANT', response.data)
          if (response.data.peppolId) {
            localStorage.setItem(
              'tenant_peppolId',
              response.data.peppolId.toString()
            )
          }
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  verifyPeppolId({ commit }, id) {
    return new Promise((resolve, reject) => {
      axios
        .get('/peppol-submissions/verify-id/' + id)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getTemplate(context, payload) {
    return new Promise((resolve, reject) => {
      axios
        .get('tenant-email-templates')
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  fetchTenant({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .get('/tenants', {
          params: payload,
        })
        .then((response) => {
          localStorage.setItem('tenantName', response.data[0].name)
          window.dispatchEvent(new Event('tenant-updated'));
          const idleTimeout = response.data[0].idleTimeoutActivated
            
           if (idleTimeout && idleTimeout > 0) {
              setIdleTimeout(idleTimeout)
            }
          
          
          commit('SET_TENANT', response.data)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
}
